import { render, staticRenderFns } from "./DictonaryItem.vue?vue&type=template&id=f438a8e0&scoped=true&"
import script from "./DictonaryItem.vue?vue&type=script&lang=js&"
export * from "./DictonaryItem.vue?vue&type=script&lang=js&"
import style0 from "./DictonaryItem.vue?vue&type=style&index=0&id=f438a8e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f438a8e0",
  null
  
)

export default component.exports